import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Launch from './views/Launch.vue'
import Login from './views/Login.vue'
import Reject from './views/Reject.vue'
import SmartGroups from './views/SmartGroups.vue'
import ManualGroups from './views/ManualGroups.vue'
import Bundles from './views/Bundles.vue'
import Settings from './views/Settings.vue'
import Faq from './views/Faq.vue'
import ContactUs from './views/ContactUs.vue'
import OrderHistory from './views/OrderHistory.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/launch/code/:code/engine/:engine/shop/:shop',
      name: 'launch',
      component: Launch
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/reject',
      name: 'reject',
      component: Reject
    },
    {
      path: '/smart-groups',
      name: 'smart-groups',
      component: SmartGroups
    },
    {
      path: '/manual-groups',
      name: 'manual-groups',
      component: ManualGroups
    },
    {
      path: '/bundles',
      name: 'bundles',
      component: Bundles
    },
    {
      path: '/settings',
      name: 'settings',
      component: Settings
    },
    {
      path: '/faq',
      name: 'faq',
      component: Faq
    },
    {
      path: '/contact-us',
      name: 'contact-us',
      component: ContactUs
    },
    {
      path: '/order-history',
      name: 'order-history',
      component: OrderHistory
    }
  ]
})
